













import { shuffle } from 'lodash';
import adjectives from '@/lib/adjectives';
import nouns from '@/lib/nouns';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { titleCase } from 'change-case';
import api_client from '@/lib/api_client';

interface Player {
  id: number;
  nickname: string;
  email: string;
}

@Component
export default class Home extends Vue {
  get playerIds() {
    return this.form.players.map((player) => {
      return player.id;
    });
  }

  get availablePlayers() {
    return this.allPlayers.filter((player) => {
      return !this.playerIds.includes(player.id);
    });
  }

  public allPlayers: Player[] = [];

  public gameTypes = [{ text: '1 v 1', value: 2 }, { text: '2 v 2', value: 4 }];
  public form = {
    type: 4,
    players: [
      {
        id: this.$store.state.profile.id,
        nickname: this.$store.state.profile.nickname,
      },
    ],
  };

  @Watch('form.type')
  public onTypeChange() {
    if (this.form.players.length > this.form.type) {
      this.form.players = this.form.players.slice(0, this.form.type);
    }
  }

  public async mounted() {
    if (!this.$store.state.loggedIn) {
      this.$store.commit('setAlert', {
        type: 'alert',
        text: 'Please log in first.',
      });
      this.$router.push({ name: 'login' });
    }
    this.allPlayers = (await api_client.get('/players')).data;
  }

  public labelFor(playerNumber: number) {
    return `Player ${playerNumber}`;
  }

  public label(object: Player) {
    return object.nickname || object.email;
  }

  public async create() {
    const response = await api_client.post('/games', {
      players: this.playerIds,
    });
    this.$router.push({ name: 'game', params: { id: response.data.id } });
  }
}
